import { ViewContextProps } from '../ViewContext';
import { FieldFragment } from '../brief.generated';

export function isFieldShown(field: FieldFragment, viewContext?: ViewContextProps): boolean {
    const isReviewMode = viewContext?.isReviewMode === true;
    const displayStatus = isReviewMode ? field.display?.review : field.display?.step;

    if (
        field.display &&
        displayStatus &&
        !['DISPLAY_STATUS_VISIBLE', 'DISPLAY_STATUS_READ_ONLY'].includes(displayStatus)
    ) {
        return false;
    }

    switch (field.__typename) {
        case 'InputField':
            return !!field.inputValue;
        case 'TextAreaField':
            return !!field.textAreaValue;
        case 'SelectChoiceField':
        case 'RadioChoiceField':
            return !!field.choiceValue;
        case 'MultiChoiceField':
            return field.multiChoiceValue.length > 0;
        case 'MultiInputField':
            return field.multiInputValue.length > 0;
        case 'WorkEntityField':
            return !!field.workEntityValue;
        case 'MultiGridChoiceField':
            return field.multiGridChoiceValue.length > 0;
        case 'FilesField':
            return field.filesValue.length > 0;
        case 'GridChoiceField':
            return !!field.choiceValue;
        case 'DateField':
            return !!field.dateValue;
        // Boolean fields should always be shown since their default value is false
        case 'BooleanField':
            return true;
        case 'IntelligentStylesField':
            return field.intelligentStylesValue.designs.length > 0;
        case 'ClientConfiguredField':
            return (
                viewContext?.isReviewMode === true &&
                (field.questionId.startsWith('design-physical-product') ||
                    (field.id === 'productOptions' &&
                        !!field.clientConfiguredValue &&
                        field.clientConfiguredValue !== '{}') ||
                    (field.id === 'referenceProjects' && !!field.clientConfiguredValue) ||
                    field.id === 'appointmentTime')
            );
        default:
            return false;
    }
}

export function isFieldEmpty(field: FieldFragment): boolean {
    switch (field.__typename) {
        case 'InputField':
            return !field.inputValue;
        case 'TextAreaField':
            return !field.textAreaValue;
        case 'SelectChoiceField':
        case 'RadioChoiceField':
        case 'GridChoiceField':
            return !field.choiceValue;
        case 'ClientConfiguredField':
            return !field.clientConfiguredValue;
        case 'WorkEntityField':
            return !field.workEntityValue;
        case 'MultiChoiceField':
            return !field.multiChoiceValue || field.multiChoiceValue.length === 0;
        case 'FilesField':
            return !field.filesValue || field.filesValue.length === 0;
        case 'MultiGridChoiceField':
            return !field.multiGridChoiceValue || field.multiGridChoiceValue.length === 0;
        case 'MultiInputField':
            return !field.multiInputValue || field.multiInputValue.length === 0;
        case 'DateField':
            return !field.dateValue;
        case 'IntelligentStylesField':
            return (
                !field.intelligentStylesValue.designs ||
                field.intelligentStylesValue.designs.length === 0
            );
        default:
            return true;
    }
}
